<template>
    <form-field v-bind="fieldProps">
        <radio-input
            v-bind="inputProps"
            :options="options"
            @change="changeBoolean($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></radio-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        computed: {
            options() {
                return [false, true].map((value) => ({
                    label: this.$t(`common.microcopy.${value}`),
                    value,
                }))
            },
        },

        methods: {
            changeBoolean(value) {
                this.change(value)
            },
        },
    }
</script>
